import React, { useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import "./PayNinja.css";

const API_1 =
  "http://localhost:3000/api/v1/admin/transactions/get-pay-ninja-txn";

const WEBHOOK_API =
  "http://localhost:3000/api/v1/admin/transactions/send-webhook";

const PayNinjaClear = () => {
  const [records, setRecords] = useState([]);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const readExcel = (file) => {
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const workbook = XLSX.read(evt.target.result, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });
      setRecords(data);
    };
    reader.readAsBinaryString(file);
  };

  const extractRefId = (row) => {
    for (let key of Object.keys(row)) {
      const normalized = key.toLowerCase().replace(/\s|_/g, "");
      if (normalized === "refid" || normalized === "referenceid") {
        return row[key];
      }
    }
    return null;
  };

  const processData = async () => {
    if (!records.length) {
      alert("Upload file first");
      return;
    }

    setLoading(true);
    setResults([]);
    setProgress(0);

    let completed = 0;
    let tempResults = [];

    for (let row of records) {
      const refId = extractRefId(row);
      if (!refId) continue;

      try {
        const res = await axios.post(API_1, {
          REFID: String(refId).trim(),
        });

        if (res.data?.statusApiResponse) {
          tempResults.push({
            ...res.data.statusApiResponse,
            webhookStatus: "Pending",
          });
        }
      } catch (err) {
        console.error("API Error:", err);
      }

      completed++;
      setProgress(Math.round((completed / records.length) * 100));
    }

    setResults(tempResults);
    setLoading(false);
  };

  const sendWebhook = async (index) => {
    const updated = [...results];

    try {
      await axios.post(WEBHOOK_API, updated[index]);
      updated[index].webhookStatus = "Sent";
      setResults(updated);
    } catch (err) {
      console.error("Webhook Error:", err);
    }
  };

  const sendAllWebhooks = async () => {
    const updated = [...results];

    for (let i = 0; i < updated.length; i++) {
      if (updated[i].webhookStatus === "Sent") continue;

      try {
        await axios.post(WEBHOOK_API, updated[i]);
        updated[i].webhookStatus = "Sent";
      } catch (err) {
        console.error("Webhook Error:", err);
      }
    }

    setResults(updated);
  };

  return (
    <div className="pn-wrapper">
      <div className="pn-container">
        <div className="pn-card">
          <h2 className="pn-title">PayNinja Status Dashboard</h2>

          <input
            type="file"
            className="pn-input"
            onChange={(e) => readExcel(e.target.files[0])}
          />

          <button
            className="pn-button"
            onClick={processData}
            disabled={loading}
          >
            {loading ? "Processing..." : "Start Processing"}
          </button>

          {loading && (
            <div className="pn-progress-section">
              <div className="pn-progress-track">
                <div
                  className="pn-progress-bar"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <div className="pn-progress-text">
                {progress}% Completed
              </div>
            </div>
          )}
        </div>

        {results.length > 0 && (
          <div className="pn-table-card">
            <button className="pn-send-all" onClick={sendAllWebhooks}>
              Send All Webhooks
            </button>

            <div className="pn-table-scroll">
              <table className="pn-table">
                <thead className="pn-table-head">
                  <tr>
                    <th>Amount</th>
                    {/* <th>Merchant Ref</th> */}
                    <th>Order ID</th>
                    {/* <th>Code</th> */}
                    {/* <th>Message</th> */}
                    <th>Status</th>
                    <th>Txn ID</th>
                    <th>UTR</th>
                    <th>Webhook</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((row, index) => (
                    <tr key={index} className="pn-table-row">
                      <td>₹ {row.AMOUNT}</td>
                      {/* <td>{row.MERCHANT_REF_NO}</td> */}
                      <td>{row.ORDER_ID}</td>
                      {/* <td>{row.RESPONSE_CODE}</td> */}
                      {/* <td>{row.RESPONSE_MESSAGE}</td> */}
                      <td>
                        <span
                          className={
                            row.RESPONSE_STATUS === "SETTLED"
                              ? "pn-status-success"
                              : "pn-status-failed"
                          }
                        >
                          {row.RESPONSE_STATUS}
                        </span>
                      </td>
                      <td>{row.TRANSACTION_ID}</td>
                      <td>{row.UTR}</td>
                      <td>
                        {row.webhookStatus === "Sent" ? (
                          <span className="pn-webhook-sent">Sent</span>
                        ) : (
                          <button
                            className="pn-webhook-btn"
                            onClick={() => sendWebhook(index)}
                          >
                            Send
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PayNinjaClear;